import React from "react";
import ReactMarkdown from "react-markdown";
import InArticleAd from "@/components/ads/InArticleAd";

const normalizeRenderedMarkdown = (markdown = "") => {
  const raw = String(markdown || "");
  const hasEscapedMarkdown = /\\[#*\-.]|\\#{2,6}|\\-\s|\d+\\\.\s/.test(raw);
  const hasInlineMarkdown = /\S\s+#{2,6}\s/.test(raw) || /\S\s+-\s+\*\*/.test(raw) || /\S\s+\d+\.\s+\*\*/.test(raw);
  if (!hasEscapedMarkdown && !hasInlineMarkdown) return raw;

  return raw
    .replace(/\s+(\\#{2,6}\s+)/g, "\n\n$1")
    .replace(/\s+(\\-\s+)/g, "\n$1")
    .replace(/\s+(\d+\\\.\s+)/g, "\n$1")
    .replace(/\\([#*\-_.!`[\]()])/g, "$1")
    .replace(/\s+(#{2,6}\s+)/g, "\n\n$1")
    .replace(/([.:!?])\s+(-\s+)/g, "$1\n$2")
    .replace(/\s+(-\s+\*\*)/g, "\n$1")
    .replace(/\s+(\d+\.\s+\*\*)/g, "\n$1")
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();
      const longHeading = trimmed.match(/^(#{2,3}\s+)(.{36,}?[?:.!])\s+(.{24,})$/u);
      return longHeading ? `${longHeading[1]}${longHeading[2]}\n\n${longHeading[3]}` : trimmed;
    })
    .join("\n");
};

export default function AdMarkdownBody({ markdown = "", components, className = "" }) {
  const blocks = normalizeRenderedMarkdown(markdown).split(/\n\s*\n/).filter(Boolean);
  const firstAdIndex = Math.min(3, Math.max(blocks.length - 1, 0));
  const markdownComponents = {
    img: ({ alt = "", ...props }) => <img {...props} alt={alt || "Article illustration"} loading="lazy" decoding="async" className="rounded-2xl border border-border shadow-lg" />,
    table: ({ children }) => <div className="my-8 overflow-x-auto rounded-2xl border border-border"><table>{children}</table></div>,
    blockquote: ({ children }) => <blockquote className="rounded-2xl border-l-4 border-primary bg-primary/10 px-5 py-4 font-semibold text-foreground">{children}</blockquote>,
    ...components,
  };

  return (
    <div className={className}>
      {blocks.map((block, index) => (
        <React.Fragment key={`${index}-${block.slice(0, 16)}`}>
          <ReactMarkdown components={markdownComponents}>{block}</ReactMarkdown>
          {index === firstAdIndex && <InArticleAd />}
        </React.Fragment>
      ))}
    </div>
  );
}